export default {
    lang: {
        name: 'Pre-ordered'
    }
}